import { render, staticRenderFns } from "./LeftChart4.vue?vue&type=template&id=ebc9b20a&scoped=true&"
import script from "./LeftChart4.vue?vue&type=script&lang=js&"
export * from "./LeftChart4.vue?vue&type=script&lang=js&"
import style0 from "./LeftChart4.vue?vue&type=style&index=0&id=ebc9b20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc9b20a",
  null
  
)

export default component.exports